import { fork, take, call, put, all } from "redux-saga/effects";

import {
  aboutUsResponse,
  contactUsResponse,
  helpUsResponse,
  newsLetterSubscriptionResponse,
} from "./actions";

import types from "./types";
import {
  getAPI,
  getAPIWithoutData,
  postAPIWithoutModule,
} from "../../api/generic";

export function* doNewsLetterSubscription() {
  while (true) {
    const { payload } = yield take(types.NEWSLETTER);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(newsLetterSubscriptionResponse(response));
  }
}

export function* doGetAboutUs() {
  while (true) {
    const { payload } = yield take(types.ABOUT_US);
    const response = yield call(getAPIWithoutData, payload);
    yield put(aboutUsResponse(response));
  }
}

export function* doGetContactUs() {
  while (true) {
    const { payload } = yield take(types.CONTACT_US);
    const response = yield call(getAPIWithoutData, payload);
    yield put(contactUsResponse(response));
  }
}

export function* doGetHelpUs() {
  while (true) {
    const { payload } = yield take(types.HELP_US);
    const response = yield call(getAPIWithoutData, payload);
    yield put(helpUsResponse(response));
  }
}

function* newsLetter() {
  yield fork(doNewsLetterSubscription);
  yield fork(doGetAboutUs);
  yield fork(doGetContactUs);
  yield fork(doGetHelpUs);
}

export default newsLetter;
